import { computed } from "vue"

export const rolesAndPermissionsRecord = (state) => {
  return computed(() => {
    return state
  })
}